const mutations =  {
  setUSBProducts(state, usbProducts) {
    state.usbProducts = usbProducts;
  },
  setUSBLicenseTexts(state, usbLicenseTexts) {
    state.usbLicenseTexts = usbLicenseTexts;
  },
  setDBUpdateStatus(state, usbData) {
    state.usbData = usbData;
  },
  setAPIError(state, isError) {
    state.isUSBAPIError = isError;
  },
  resetDBResponse(state, usbData) {
    state.usbData = usbData;
  }
};

export default mutations;